import type { Baseline, OneOfListElements } from '@shared/models/project.model';
import { isDeactivated, isDeleted } from './element.helpers';
import { isElement } from './recursive-element.helpers';
import { OptionalReadonly } from '@shared/models/type-helpers.model';

/**
 * Element list rows that count toward version-level CO₂ / cost when aggregated
 * (e.g. SBEF group headers). Excludes deactivated and deleted.
 *
 * @param items Rows in one SBEF (or other) group, typically root elements
 * @param version Selected building version (unused; kept for call-site stability)
 */
export const filterListElementsContributingToVersionTotals = (
  items: OptionalReadonly<OneOfListElements[]>,
  _version: Baseline | undefined,
): OneOfListElements[] => {
  // Unified proposals: same visibility rules as former v2 (do not treat inactive-version rows as deactivated here).
  const treatInactiveVersionsAsDeactivated = false;
  return items.filter((el) => {
    if (!isElement(el)) return true;
    return (
      !isDeactivated(el, treatInactiveVersionsAsDeactivated) && !isDeleted(el)
    );
  });
};
